module.exports = __webpack_public_path__ + "static/media/education.3a75804b.svg";